import moment from 'moment'
import { WizClassifySelect } from '@/containers/common';
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = () => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "申请类型",
      name: "applyType",
      dataIndex: "applyType",
      tableItem: {},
      dict: [
        { code: 0, codeName: "新课程申请" },
        { code: 1, codeName: "课程更新申请" },
      ],
    },
    {
      title: "新版本号",
      name: "versionNumber",
      dataIndex: "versionNumber",
      tableItem: {},
      width:100
    },
    {
      title: "状态",
      name: "status",
      dataIndex: "status",
      tableItem: {},
      dict: [
        { code: 0, codeName: "已申请" },
        { code: 1, codeName: "已确认申请" },
        { code: 2, codeName: "已取消申请" }
      ],
    },
    {
      title: "申请人",
      name: "applicantFullName",
      dataIndex: "applicantFullName",
      tableItem: {}
    },
    {
      title: "培训公司",
      name: "trainCompanyName",
      dataIndex: "trainCompanyName",
      tableItem: {}
    },
    {
      title: "申请时间",
      name: "createTime",
      dataIndex: "createTime",
      tableItem: {}
    },
    {
      title: "修改申请时间",
      name: "applyTime",
      dataIndex: "applyTime",
      tableItem: {}
    },
    {
      title: "操作",
      name: "operation",
      dataIndex: "operation",
      tableItem: {},

      render: (text, record) => {
        return (
          <span>
          <a >查看</a>
        </span>
        )

      },
    },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'courseApplication/getListByPage',
    ...api
  }
}

const program = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'name',
    columns: columns(),
    tableApi: tableApi(api),
    searchProps: {
      dataFormat: (v) => {
        let value = Object.assign([], v)
        if (value['programDate'] && value['programDate'].length === 2) {
          value['startDate'] = moment(value['programDate'][0]).format("YYYY-MM-DD HH:mm:00")
          value['endDate'] = moment(value['programDate'][1]).format("YYYY-MM-DD HH:mm:59")
        }
        delete value['programDate']

        return value
      }
    },
  }
}

export default program
